<template>
    <div v-if="props.items[0]?.typez === 'cat'" style="height: 56px !important" class="pt-24 left-0 text-midnight-800 hb20">
        {{ props.items[0].name }}
    </div>
    <div v-else class="grid-container-base pt-24" :style="gridTemplateStyle">
        <ProductItem v-for="(product, key) in items" :key="key" :product="product" :grid="true" :isStepperExpanded="false" @clickProduct="emit('click-product', product)"/>
    </div>
</template>
<script setup lang="ts">
import ProductItem from './ProductItem.vue';
import {Product} from '../../store/products';
import {computed} from 'vue';

const emit = defineEmits<{
    (event: 'click-product', product: Product): void,
}>();

const props = defineProps<{
    items: (Product & { typez: string, name: string })[],
    columns: number,
}>();

const gridTemplateStyle = computed(() => {
    return {
        gridTemplateColumns: `repeat(${props.columns}, 1fr)`,
    };
});
</script>
<style lang="scss">
.grid-container-base {
    display: grid;
    gap: 1rem;
    width: 100%;
}
</style>
